// extracted by mini-css-extract-plugin
module.exports = {"externalContainer":"styles_externalContainer__3IJkg","container":"styles_container__2IhzR","contentGrid":"styles_contentGrid__NolWs","grayBar":"styles_grayBar__2EcIQ"};